import { FormControl, TextField } from '@mui/material';
import { Asterisk, FieldLabel } from 'components/modals/addPostModal/PostDetailsForm';
import { ConfigEntryType } from 'config/config';
import { Controller, useFormContext } from 'react-hook-form';

type TextInputFieldProps = {
  field: ConfigEntryType;
  showLabel?: boolean;
};

function TextInputField({ field, showLabel }: TextInputFieldProps) {
  const {
    control,
    formState: { isSubmitting },
  } = useFormContext<Record<string, any>>();

  return (
    <>
      {field && !showLabel && (
        <FieldLabel id={field.entryCode} disabled={isSubmitting}>
          {field.referenceObject?.label || field.entryDescription}
          {field.referenceObject?.isRequired && <Asterisk>*</Asterisk>}
        </FieldLabel>
      )}
      <Controller
        control={control}
        render={({ field: _field, fieldState }) => (
          <FormControl fullWidth sx={showLabel ? { my: 1 } : { my: 1, mb: 2 }}>
            <TextField
              {..._field}
              size="small"
              multiline
              value={!!_field?.value?.trim() ? _field.value : ''}
              inputProps={{ maxLength: field.entryCode === 'title' ? 250 : 50 }}
              fullWidth
              {...(!showLabel && {
                placeholder: field.referenceObject?.placeHolder || 'Enter value',
                InputLabelProps: { shrink: true },
              })}
              {...(showLabel && {
                label: (
                  <span>
                    {field.referenceObject?.label || 'Select'}
                    {field.referenceObject?.isRequired && <Asterisk>*</Asterisk>}
                  </span>
                ),
                inputProps: {
                  sx: {
                    padding: '4px 0 5px',
                  },
                },
              })}
              variant="standard"
              error={!!fieldState.error}
              helperText={fieldState?.error?.message || ''}
              disabled={isSubmitting}
            />
          </FormControl>
        )}
        name={field.entryCode}
      />
    </>
  );
}

export default TextInputField;
